<template lang="pug">
  div
    SingleNumWrapper(
      :chartType="'wafsumnum'"
      :chartTitle="$t('dashboard.wafEventCount')"
      :maxFontSize="'42px'"
      :withCard="withCard"
    )
    LineChartWrapper(
      :chartType="'waflinechart'"
      :chartDataSetLabel="[$t('dashboard.wafEventCount')]"
      :titleDisplay="false"
      :withCard="withCard"
      :chartWidth="600"
      :chartHeight="100"
      :xAxesDisplay="false"
      :yAxesDisplay="false"
      :legendDisplay="false"
      :lineBorderColors="[colorScheme.darkYellow.border]"
      :lineBackgroundColors="[colorScheme.darkYellow.fillTransparent]"
     :withPropRawBtn="false"
      )
</template>
<script>
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";
import colorScheme from "@/data/colorScheme";

export default {
    components: { SingleNumWrapper, LineChartWrapper },
    props: {
        dateRange: {
            type: String,
            default: "1"
        },
        customTimeRange: {
            type: Array,
            default: () => ["", ""]
        },
        withCard: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            colorScheme: colorScheme
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/components/HomePage/WebProtectionCard.vue